// extracted by mini-css-extract-plugin
export var cartContainer = "_lz-4";
export var gray = "_lz-1";
export var itemContainer = "_lz-2";
export var itemDetails = "_lz-3";
export var strong = "_lz-0";